import { type DropdownMenuItem } from "../dropdown-menu/DropdownMenu";
import type { DmPendingAmendment } from "../../app/services/dmThreads";

interface BuildContractActionMenuArgs {
  onCloseRequest?: () => void;
  onContractUpdate?: () => void;
  /**
   * 受託者が同プロジェクトで進行中の再委託オファー（子オファー）を抱えているか。
   * 親側でクローズを発動すると子オファーの原資（`committed_incoming` 由来の
   * lock）と整合が取れなくなるため、暫定対応として disabled にする。
   */
  hasActiveChildSubcontracts?: boolean;
  /** 承認待ちの契約更新。あるときは二重提案を避けて「契約書を更新」を止める。 */
  pendingAmendment?: DmPendingAmendment | null;
}

/**
 * 契約アイテムの 3 点メニュー項目を組み立てる。
 *
 * 初回の契約書（`ContractTimelineItem`）と契約更新（`ContractAmendedTimelineItem`）
 * で共有する。契約が更新されるとタイムラインに複数の版が並ぶため、この操作は
 * **現在有効な版**のアイテムにだけ出す（呼び出し側が判断する）。
 */
export const buildContractActionMenuItems = ({
  onCloseRequest,
  onContractUpdate,
  hasActiveChildSubcontracts = false,
  pendingAmendment,
}: BuildContractActionMenuArgs): DropdownMenuItem[] => {
  const items: DropdownMenuItem[] = [];

  if (onCloseRequest) {
    items.push({
      label: hasActiveChildSubcontracts
        ? "クローズを相談（再委託中のため不可）"
        : "クローズを相談",
      onClick: onCloseRequest,
      disabled: hasActiveChildSubcontracts,
    });
  }

  if (onContractUpdate) {
    // 提案中は BE 側では上書きになるが、受託者が承認しようとしている内容が
    // 黙って差し替わるのを防ぐため無効化する。
    items.push({
      label: pendingAmendment
        ? "契約書を更新（承認待ちのため不可）"
        : "契約書を更新",
      onClick: onContractUpdate,
      disabled: !!pendingAmendment,
    });
  }

  return items;
};
